import React, { useState, useEffect } from "react";
import newzerosblackmainmenu from "../../asset/images/Zarp Logo.png";
import Mainmenu from "./Mainmenu";
import { AES, enc } from "crypto-js";

function Leftbar(props) {
  const { navigation } = props;
  const [apiData, setApiData] = useState([]); // State to store the API data
  const encryptedUniqueId = localStorage.getItem("uniqueId1");
  
  // Decrypt uniqueId only if it exists
  let decryptedUniqueId = "";
  if (encryptedUniqueId) {
    try {
      decryptedUniqueId = AES.decrypt(
        encryptedUniqueId,
        "1234567812345678"
      ).toString(enc.Utf8);
    } catch (error) {
      console.error("Error decrypting uniqueId:", error);
    }
  }
  
  const apiUrl = `https://trading.zarpsoftware.in/jps/JpserpApi/getEmpMenuByEmpId`;

  const fetchData = () => {
    const jwtToken = localStorage.getItem("jwtToken");
    const empId = localStorage.getItem("employeeId") || localStorage.getItem("userId"); // Fallback to userId
    
    // Check if required data exists before making API call
    if (!empId) {
      console.warn("employeeId/userId not found in localStorage. Using default menu.");
      // Set empty array so menu still renders with default items
      setApiData([]);
      return;
    }
    
    if (!decryptedUniqueId) {
      console.warn("uniqueId not found in localStorage. Using default menu.");
      setApiData([]);
      return;
    }
    
    if (!jwtToken) {
      console.warn("jwtToken not found in localStorage. Using default menu.");
      setApiData([]);
      return;
    }
    
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${jwtToken}`
      },
      body: JSON.stringify({
        emp_id: empId,
        uniqueId: decryptedUniqueId,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.status === "success") {
          setApiData(data.message); // Set the fetched data to the state
        } else {
          console.error("Error fetching portfolio data");
        }
      })
      .catch((error) => {
        // CORS errors will show as "Failed to fetch"
        if (error.message === "Failed to fetch") {
          console.error("CORS error: Backend doesn't allow requests from localhost. This is a backend configuration issue.");
        } else {
          console.error("Error fetching portfolio data:", error);
        }
      });
  };

  // Use useEffect to call the API when the component mounts
  useEffect(() => {
    fetchData();
  }, []); // Empty dependency array means this runs once on mount

  return (
    <div className="sidebar text-dark" style={{ backgroundColor: "#ffffff" }}>
      <div className="sidebar-scroll">
        <div className="user-account">
          <img
            src={newzerosblackmainmenu}
            alt="User Profile Picture"
            style={{ width: "60%" }}
          />
        </div>

        <Mainmenu navigation={navigation} apiData={apiData} />
      </div>
    </div>
  );
}

export default Leftbar;
